import { createContext } from 'react';

export interface UserEmailManagement {
  email: string | undefined;
  refresh: () => Promise<string | undefined>;
}

export function dummyRefresh(): Promise<string> {
  throw new Error(`Tried to refresh email outside of UserEmailManagementHandler`);
}

export const userEmailManagementContext = createContext<UserEmailManagement>({
  email: undefined,
  refresh: dummyRefresh,
});
